import { get, postj } from '@/utils/request';

export const list = (param) => get('order/ratelist',param); // 订单列表
export const rateDel = (data) => postj('order/rateDel',data); // 删除报价

export const fbaData = (param) => get('fba/data',param); // 用户信息及报价列表
export const fbaPrice = (data) => postj('fba/price',data); // 获取报价